<div [class.impaired]="isImpaired" class="contact-container" *ngLet="breakPointObserve$ | async">
  <form *ngIf="!loader" class="contact-container__form" [formGroup]="form">
    <ng-container
      *ngTemplateOutlet="
        clearableInput;
        context: { control: 'surname', value: form.controls.surname.value , name: 'OTHER.CONTACTS_FORM.SURNAME', placeholder: 'VERSION_VISUALLY_IMPAIRED.PLACEHOLDER_SURNAME' }
      "
    ></ng-container>
    <ng-container
      *ngTemplateOutlet="
        clearableInput;
        context: { control: 'name', value: form.controls.name.value, name: 'OTHER.CONTACTS_FORM.NAME', placeholder: 'VERSION_VISUALLY_IMPAIRED.PLACEHOLDER_FIRSTNAME' }
      "
    ></ng-container>
    <ng-container
      *ngTemplateOutlet="
        clearableInput;
        context: { control: 'secondName', value: form.controls.secondName.value, name: 'OTHER.CONTACTS_FORM.PATRONYMIC', placeholder: 'VERSION_VISUALLY_IMPAIRED.PLACEHOLDER_SECONDNAME' }
      "
    ></ng-container>
    <ng-container
      *ngTemplateOutlet="
        clearableInput;
        context: {
          control: 'email',
          name: 'OTHER.CONTACTS_FORM.EMAIL',
          errorMessage: 'OTHER.CONTACTS_FORM.EMAIL_ERROR',
          placeholder: 'VERSION_VISUALLY_IMPAIRED.PLACEHOLDER_EMAIL'
        }
      "
    ></ng-container>
    <ng-container
      *ngTemplateOutlet="
        clearableInput;
        context: {
          control: 'telephone',
          name: 'OTHER.CONTACTS_FORM.TELEPHONE',
          mask: '0-000-000-00-00',
          errorMessage: 'OTHER.CONTACTS_FORM.TELEPHONE_ERROR',
          placeholder: 'VERSION_VISUALLY_IMPAIRED.PLACEHOLDER_TELEPHONE'
        }
      "
    ></ng-container>

    <br *ngIf="!isImpaired">
    <app-captcha *ngIf="step" [isImpaired]="isImpaired" formControlName="captcha"></app-captcha>
  </form>
  <app-loader *ngIf="loader"></app-loader>
  <div class="footer mt32 mb24" *ngIf="!loader">
    <span *ngIf="!isImpaired" class="caption-2 footer_text">*{{ 'OTHER.REQUIRED' | translate }}</span>
    <div [class.impaired]="isImpaired" class="footer__button__container">
      <button
        [ngClass]="{ 'button2-impaired': isImpaired, 'btn-secondary medium': !isImpaired }"
        class="mr16"
        [matTooltip]="cancelNameTooltip | translate"
        (click)="cancel()"
      >
        {{ cancelName | translate }}
      </button>
      <button
        [ngClass]="{ 'button2-impaired': isImpaired, 'btn-primary medium': !isImpaired }"
        [disabled]="form.invalid || loader"
        (click)="sendForm()"
      >
        {{ 'OTHER.SEND' | translate }}
      </button>
    </div>
  </div>
</div>

<ng-template #clearableInput let-control="control" let-value="value" let-name="name" let-mask="mask" let-errorMessage="errorMessage" let-placeholder="placeholder">
  <div *ngIf="!isImpaired" class="clearable-input" [formGroup]="form">
    <mat-form-field appearance="outline" class="appeal-input">
      <mat-label>{{ name | translate }}</mat-label>
      <input matInput [formControlName]="control" [value]="value"  [mask]="mask" (keydown.enter)="enterEvent($event)" />
    </mat-form-field>
    <button
      class="btn-empty clear-btn"
      type="button"
      [style.color]="form.get(control)?.errors ? '#AA0000' : '#B2B5BB'"
      (click)="form.get(control)?.reset()"
      *ngIf="form.get(control)?.value"
    >
      <svg [icon]="icons.CloseRound" class="svg24"></svg>
    </button>
    <small [style.color]="'red'" *ngIf="errorMessage && form.get(control)?.errors && form.get(control)?.touched">{{
      errorMessage | translate
    }}</small>
  </div>

  <app-impaired-input
    *ngIf="isImpaired"
    placeholder="{{ placeholder | translate }}"
    header="{{ name | translate }}"
    [mask]="mask"
    errorMessage="{{ errorMessage | translate }}"
    [control]="$any(form.controls[control])"
  ></app-impaired-input>
</ng-template>
